import { handleActions, combineActions } from 'redux-actions'
import { fromJS } from 'immutable'

import * as Actions from 'actions/media_reviews'
import * as AppActions from 'actions/app'

export const initialState = fromJS({
  filter: [],
  dateFrom: null,
  dateTo: null,
  page: 0,
  pageSize: 25,
  totalCount: 0,
  filterRequestRunning: false
})

export default handleActions({
  [Actions.setMediaReviewFilter]: (state, { payload }) => state.set('filter', fromJS(payload)),
  [Actions.setMediaReviewDateRange]: (state, { payload }) => {
    const { dateFrom, dateTo } = payload || {}

    return state.withMutations(next => {
      if (dateFrom !== undefined) {
        next.set('dateFrom', dateFrom)
      }

      if (dateTo !== undefined) {
        next.set('dateTo', dateTo)
      }
    })
  },
  [Actions.setMediaReviewsPagination]: (state, { payload }) => {
    const { page, pageSize } = payload || {}

    return state.withMutations(next => {
      if (page !== undefined) {
        next.set('page', page)
      }

      if (pageSize !== undefined) {
        next.set('pageSize', pageSize)
      }
    })
  },
  [Actions.setMediaReviewsTotalCount]: (state, { payload }) => state.set('totalCount', payload || 0),
  [Actions.filterMediaReviewsStart]: state => state.set('filterRequestRunning', true),
  [Actions.filterMediaReviewsSuccess]: (state, { payload }) => state.set('totalCount', (payload && payload.totalCount) || 0),
  [combineActions(
    Actions.filterMediaReviewsSuccess,
    Actions.filterMediaReviewsError
  )]: state => state.set('filterRequestRunning', false),

  [AppActions.resetState]: () => initialState
}, initialState)
